import { render, staticRenderFns } from "./PayLater.vue?vue&type=template&id=5720439a"
import script from "./PayLater.vue?vue&type=script&lang=js"
export * from "./PayLater.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports